import { render, staticRenderFns } from "./MediaFiles.vue?vue&type=template&id=53f7c1b4&scoped=true"
import script from "./MediaFiles.vue?vue&type=script&lang=js"
export * from "./MediaFiles.vue?vue&type=script&lang=js"
import style0 from "./MediaFiles.vue?vue&type=style&index=0&id=53f7c1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f7c1b4",
  null
  
)

export default component.exports